// extracted by mini-css-extract-plugin
export default {"form":"PasswordReset_form__IMfli","title":"PasswordReset_title__yupox"};